<template>
  <div class="see-more" @click="seeMore">
    <span>{{name}}</span>
    <i class="el-icon-arrow-right"></i>
  </div>
</template>

<script>
export default {
  name: "SeeMore",
  props: {
    next: {
      type: Object,
      required: true
    },
    name:{
      type:String
    }
  },
  methods: {
    seeMore() {
      if(this.next.data && this.next.data.id) {
        this.$router.push({name:this.next.next,query: { id:this.next.data.id || ''}})
      } else {
        this.$router.push({name:this.next.next})
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";

.see-more {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 128px;
  height: 32px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 32px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  cursor: pointer;
  border: 1px solid rgba(102, 102, 102, 1);
  border-radius: 25px;

  i {
    transition: $transition-primary;
  }

  &:hover {
    color: $color-primary;
    border-color: $color-primary;
    transform: scale(1.03);

    i {
      right: 10px;
    }
  }
}
</style>
